import client from "@/services/api"


export const getLatestVersion = () => {
    return client.get(`/clients/versions/latest-by-type?type=panel`)
}